import hatsApi from '@/services/hatsApi'

export default {
  search (params) {
    let filter = params || ''
    return hatsApi().get('/system/station/?filter=' + unescape(JSON.stringify(filter)))
  }
}



// WEBPACK FOOTER //
// ./src/services/hatsApi/Station.js